import { createContext } from '@flex-design-system/fx';

const [FileUploadProvider, useFileUploadContext] = createContext("FileUpload");

export { FileUploadProvider, useFileUploadContext };
//# sourceMappingURL=context.mjs.map
